import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  theme => ({
    optionIcon: {
      marginRight: '5px',
    },
    subHeaderBox: {
      display: 'flex',
      justifyContent: 'space-between',
      maxWidth: '1200px',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },
    filtersBox: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '100%',
      },
    },
    inputStyle: {
      '& fieldset legend': {
        width: 'unset',
      },
      margin: '0px 15px',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        margin: '10px 0px',
      },
    },
    buttonStyle: {
      [theme.breakpoints.down('sm')]: {
        margin: '6px 0px',
      },
    },
    tableBox: {
      border: '1px solid #666',
      borderRadius: '8px',
    },
    modalText: {
      marginBottom: '12px',
    },
    modalButtonBox: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: '12px',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column-reverse',
      },
    },
    buttonForm: {
      paddingRight: 0,
      paddingLeft: 0,
      marginTop: '25px',
      '@media print': {
        display: 'none',
      },
    },
    textContentResume: {
      color: '#000',
      textAlign: 'center',
    },
    successIconTitle: {
      width: '40px',
      height: 'auto',
      marginRight: '12px',
    },
    formBox: {
      maxWidth: '400px',
      margin: 'auto',
      '@media print': {
        maxWidth: 'initial',
      },
    },
    labelValueBox: {
      marginBottom: '8px',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      '@media print': {
        display: 'block',
      },
    },
    successModalLabel: {
      color: '#000',
    },
    modalPdf: {
      textAlign: 'center',
      padding: '10px',
      [theme.breakpoints.down('sm')]: {
        margin: 10000,
      },
    },
    modalAlert: {
      color: '#FF7A00',
    },
    warning: {
      margin: 30,
    },
    typography: {
      textAlign: 'center',
    },
    modalButton: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: 30,
    },
    modalButtonW: {
      width: '100px',
    },

    textModal: {
      alignItems: 'center',
    },
  }),
  { index: 1 },
);

export default useStyles;
